import { Icon } from "@chakra-ui/react";
function WarningIcon() {
  return (
    <Icon
      width="5"
      height="5"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      color="brand.alert.warningIconColor"
    >
      <path
        d="M10.3915 2.51833C11.5279 3.65476 11.5279 5.49727 10.3915 6.63369C9.25508 7.77012 7.41257 7.77012 6.27615 6.63369C5.13972 5.49727 5.13972 3.65476 6.27615 2.51833C7.41257 1.38191 9.25508 1.38191 10.3915 2.51833"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9695 10.663C10.887 10.2305 9.61699 9.99219 8.33366 9.99219C4.96033 9.99219 1.66699 11.6314 1.66699 14.1522V14.9855C1.66699 15.4455 2.04033 15.8189 2.50033 15.8189H10.3445"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1667 18.3333C11.8658 18.3333 10 16.4683 10 14.1667C10 11.9133 11.9167 9.9975 14.17 10C16.47 10.0017 18.3333 11.8667 18.3333 14.1667C18.3333 16.4675 16.4683 18.3333 14.1667 18.3333"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1667 13.9831V12.3164"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1675 16.0403C14.2317 16.0403 14.2833 15.9886 14.2825 15.9245C14.2825 15.8603 14.2308 15.8086 14.1667 15.8086C14.1025 15.8086 14.0508 15.8603 14.0508 15.9245C14.0508 15.9886 14.1025 16.0403 14.1675 16.0403"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Icon>
  );
}

export default WarningIcon;
